<template>
  <div class="ximi-container">
    <Nav></Nav>
    <div class="ximi-banner">
      <div class="banner-content">
        <div class="title flex-center">
          <img src="../assets/images/ximi/logo-xi.png" alt="">
        </div>
        <div class="banner-texts">
          上百个功能，可以轻松实现设计项目的“杀毒与故障处理、一键楼梯、单双面建模、一键柜子酒格、材质转换、一键灯带、一键代理、一键生长动画、VR与CR智能批量渲染、ACEScg工作流、笔刷种植、模型转CAD、自带材质库、SU导入MAX”等全方位、新工具，让你拥有更高效的Max设计效率！
        </div>
        <div class="banner-submits">
          <a 
            href="https://pan.baidu.com/s/1W8ROkPT9bvM2jSFgvS2U2w?pwd=XIMI#list/path=%2F" 
            target="_blank" 
            class="btn btn-primary">
            免费下载试用 <i class="el-icon-right"></i>
          </a>
        </div>
        <div class="banner-text-main">
          <p>版本 5.19，更新时间：2024/8/2</p>
          <p>支持Max2014-Max2025 (64 bit)</p>
          <p>支持Vray 2.0 - 6.2+ 、Corona 1.7 - 12 、FStorm 1.0 - 1.5.3</p>
        </div>
      </div>
    </div>
    <div class="sogoRenderWork flex-center">
      <div class="banXin">
        <div class="renderTitle">渲染建模，高效作业 </div>
        <div class="renderMark">西米工具箱，满足您在3ds Max作图渲染领域的全方位需求。无论是高效管理素材，优化复杂场景，或是快速构建模型，一键渲染，都能为您提供流畅体验，助您迅速完成各项工作
        </div>
        <el-row :gutter="20" class="renderWrap">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="6">
            <div  class="renderItem flex-center flex-align-center">
              <img src="../assets/images/ximi/素材.png" alt="西米工具箱" class="renderItemImg sucai">
              <div class="renderItemTitle">素材管理</div>
              <div class="renderItemMark">超强素材库支持网上绝大部分素材直接导入，无需任何手动整理支持压缩包直接导入，无需解压。</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="6" >
            <div class="renderItem flex-center flex-align-center">
              <img src="../assets/images/ximi/建模.png" alt="西米工具箱" class="renderItemImg jianmo">
              <div class="renderItemTitle">快速建模</div>
              <div class="renderItemMark">急速单双面建模系统，节省大量基础操作的时间，减少加班概率。</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="6" >
            <div class="renderItem  flex-center flex-align-center">
              <img src="../assets/images/ximi/智能.png" alt="西米工具箱" class="renderItemImg xuanran">
              <div class="renderItemTitle">智能渲染</div>
              <div class="renderItemMark">特邀 VR 官方认证讲师，针对渲染质量和渲染速率平衡的优化，包括透视/全景/动画三方面的极速渲染。</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="6" >
            <div class="renderItem  flex-center flex-align-center">
              <img src="../assets/images/ximi/病毒查杀.png" alt="西米工具箱" class="renderItemImg bingdu">
              <div class="renderItemTitle">病毒查杀</div>
              <div class="renderItemMark">MAX启动自动杀毒，解决渲染，撤回和弹窗各种卡顿崩溃问题，一键清理场景垃圾、杜绝场景卡顿。</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="sogoHeightPaly flex-align-center flex-center">
      <div class="banXin">
        <div class="renderTitle">西米工具箱，找到更高级的玩法</div>
        <div class="renderMark">感受西米工具箱满足您在3ds Max作图渲染上的各种需求，无论是建模还是渲染，亦或者一键绘图，都可以让您拥有从未有过的流畅感，快速完成工作</div>
        <div class="sogoHPalyWrap flex-align-center">
          <div class="sogoHPLeft">
            <div 
              @click="active = index"
              class="sogoHPLItem " 
              :class="{ 'sogoHPLItemAct' : active == index }"
              v-for="(item, index) in HPList" 
              :key="index">
              <span>{{ item.title }}</span>
              <div class="sogoHPLItemMark">
                {{ item.desc }}
              </div>
            </div>
          </div>
          <div class="sogoHPRight hidden-sm-and-down" >
            <img 
              style="max-height: 450px;"
              v-for="(item, index) in HPList"
              :key="index"
              :src="item.img" 
              v-show="active == index"
              alt="西米工具箱" 
              class="gifImg" 
              id="gif1">
          </div>
        </div>
      </div>
    </div>
    <div class="sogoDesignerLove flex-align-center flex-center">
      <div class="banXin">
        <div class="renderTitle">这些功能，深受设计师喜爱</div>
        <div class="renderMark">满足您在每个阶段使用需求，帮助您高效完成工作及任务</div>
        <div class="designWrap flex-between flex-wrap flex-align" >
          <div class="designItem">
            <div class="designItemTitle">模型复制黏贴</div>
            <div class="designItemMark">复制模型/灯光/材质/相机/不丢失贴图</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">材质复制粘贴</div>
            <div class="designItemMark">快速复制A场景材质并粘贴到B场景</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">CAD导入</div>
            <div class="designItemMark">CAD自动坐标归0，冻结CAD，压平CAD</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">SU导入MAX</div>
            <div class="designItemMark">SU导入MAX的模型自动塌陷并焊接</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">归档打包</div>
            <div class="designItemMark">快50%~80%，打包选择对象、贴图单独整理</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">资源检测</div>
            <div class="designItemMark">轻松快速找回场景丢失的贴图</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">全面体检</div>
            <div class="designItemMark">一键检查是否存在各种问题，场景各种奇怪问题一键解决</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">杀毒与故障处理</div>
            <div class="designItemMark">启动自动杀毒，再也不怕Max中毒崩溃</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">截面库</div>
            <div class="designItemMark">一键生成吊顶，角线，踢脚线，门套线等</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">柜子设计</div>
            <div class="designItemMark">快速生成柜子、隔板、柜门、把手</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">材质转换</div>
            <div class="designItemMark">支持任何汉化VR/CR，材质灯光完美转换</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">阵列拼接</div>
            <div class="designItemMark">一键生成没有接缝的阵列拼接/围墙</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">一键楼梯</div>
            <div class="designItemMark">一键楼梯，一键换护手/立柱/立杆</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">笔刷种植</div>
            <div class="designItemMark">一键生成道路，摆放车辆，生成斑马线等</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">蜂窝材质</div>
            <div class="designItemMark">快速赋予常用材质</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">提取截面</div>
            <div class="designItemMark">一键提取截面，生成特殊隔板造型</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">投影吸附</div>
            <div class="designItemMark">一键模型吸附曲面</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">相机分辨率设置</div>
            <div class="designItemMark">每个相机单独设置分辨率，方便查看渲染</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">VR与CR智能渲染设置</div>
            <div class="designItemMark">VR与CR透视/全景/动画渲染极速设置</div>
          </div>
          <div class="designItem">
            <div class="designItemTitle">更多功能</div>
            <div class="designItemMark">实时更新中，更多功能请下载体验…</div>
          </div>
        </div>
      </div>
    </div>
    <div class="sogoDesignerLove flex-align-center flex-center">
      <div class="banXin">
        <div class="renderTitle"> 西米工具箱视频演示 </div>
        <div class="renderMark"> 感受工具箱带来的速度与激情吧</div>
        <div class="renderVideo">
          <video src="https://client.renderg.com:6443/download/video/video.mp4" id="myVideo" controls="controls"></video>
        </div>
      </div>
    </div>
    <div class="sogoMorePriceWrap flex-align-center flex-center">
      <div class="sogoMorePrice flex-align-center flex-center">
        <div class="banXin">
          <div class="renderTitle">更多的价格选择，让您轻松无负担</div>
          <div class="renderMark">西米工具箱提供免费试用，请体验满意再付费购买，本产品为虚拟产品，一经售出后不支持退换哦</div>
          <div class="designWrap ">
            <div class="memberItem experMember">
              <img src="../assets/images/ximi/newUserTip.svg" alt="西米工具箱" class="permanMemberFree">
              <div class="memberItemTop">
                <div class="memberTitle">体验会员</div>
                <div class="memberPrice flex-align-center flex-center">
                  <span class="priceIcon">¥</span><span class="memberPriceNum experMemberPrice">0</span>/7天
                </div>
                <div class="memberBtn experMemberBtn downloadA" @click="payForX()">
                  立即体验
                </div>
                <!-- <a class="memberBtn experMemberBtn downloadA" id="experMember" target="_blank">立即体验</a> -->
              </div>
              <div class="memberItemBott">
                <div class="memberItemTxt">会员特权：</div>
                <div class="memberItemMark">体验会员为7天</div>
                <div class="memberItemMark"></div>
              </div>
            </div>
            <div class="memberItem monthMember">
              <div class="memberItemTop">
                <div class="memberTitle">月卡会员</div>
                <div class="memberPrice flex-align-center flex-center">
                  <span class="priceIcon">¥</span>
                  <span class="memberPriceNum monthMemberPrice" id="MONTHLY_PASS_NUM">38</span>
                  <span id="MONTHLY_PASS_Uity">/月</span>
                </div>
                <div class="memberBtn monthMemberBtn" @click="payForX()">立即购买</div>
              </div>
              <div class="memberItemBott">
                <div class="memberItemTxt">会员特权：</div>
                <div class="memberItemMark">西米工具箱30天会员卡</div>
                <div class="memberItemMark">送渲酷云渲染价值 <span class="originColor">38元永久代金券</span></div>
              </div>
            </div>
            <div class="memberItem seasonMember">
              <div class="memberItemTop">
                <div class="memberTitle">年卡会员</div>
                <div class="memberPrice flex-align-center flex-center">
                  <span class="priceIcon">¥</span><span class="memberPriceNum seasonMemberPrice" id="YEAR_PASS_NUM">338</span>
                  <span id="YEAR_PASS_Uity">/年</span>
                </div>
                <div class="memberBtn seasonMemberBtn" @click="payForX()">立即购买</div>
              </div>
              <div class="memberItemBott">
                <div class="memberItemTxt">会员特权：</div>
                <div class="memberItemMark">西米工具箱365天会员卡</div>
                <div class="memberItemMark">送渲酷云渲染价值 <span class="originColor">338元永久代金券</span> </div>
              </div>
            </div>
            <div class="memberItem permanMember">
              <img src="../assets/images/ximi/限时特惠.svg" alt="西米工具箱" class="permanMemberFree" id="permanTeIcon" style="">
              <div class="memberItemTop priceFreeWrap">
                <div class="memberTitle">终身会员</div>
                <div class="memberPrice flex-align-center flex-center priceFlexColumn">
                  <div class="flex-align-center flex-center priceFlexCon">
                    <span class="priceIcon">¥</span><span class="memberPriceNum permanMemberPrice" id="LIFELONG_PASS_NUM">688</span>
                  <span id="LIFELONG_PASS_Uity">/永久</span>
                  </div>
                  <div class="priceHeng">原价¥788/永久</div>
                </div>
                <div class="memberBtn permanMemberBtn" @click="payForX()">立即购买</div>
                <!-- <div class="priceTimeFree">活动截止至2025/06/30</div> -->
              </div>
              <div class="memberItemBott">
                <div class="memberItemTxt">会员特权：</div>
                <div class="memberItemMark">西米工具箱永久免费使用</div>
                <div class="memberItemMark">送渲酷云渲染价值 <span class="originColor">688元永久代金券</span></div>
              </div>
            </div>

          </div>
          <div class="memberTip">
            <div class="preTitle">温馨提示：</div>
            <div class="preItemWrap">
              <span class="preItem"><span class="num">1.</span><span class="con">西米工具箱是一款账号登录式的软件，是不绑定任何机器的，所以不必担心传统软件的由于更换设备而导致的无法使用的问题。您走到哪里都能用，无论哪台机器，有网没网都可以登录。</span></span>
              <span class="preItem"><span class="num">2.</span><span class="con">西米工具箱是可以免费试用所有功能的。我们从不强制您购买，您完全可以一直用到您觉得物有所值，再考虑是否购买会员。<a href="https://pan.baidu.com/s/1W8ROkPT9bvM2jSFgvS2U2w?pwd=XIMI#list/path=%2F" class="originColorBlank downloadA" target="_blank">立即下载&gt;&gt;</a></span></span>
              <span class="preItem"><span class="num">3.</span><span class="con">点击这里可以<a target="_blank" class="originColor lookGoRecord downloadA goLinkSagoToolKit" href="https://s.rendercool.com/#/work/consume">查看购买记录</a>。</span></span>
              <span class="preItem"><span class="num">4.</span>
                <span class="con">
                  售后联系方式：QQ： 
                  <el-tooltip class="item" effect="dark" content="点击复制" placement="top">
                    <span class="originColor triangPopup" @click="doCopy('800089954')">800089954 </span>
                  </el-tooltip>；
                  QQ群：
                  <el-tooltip class="item" effect="dark" content="点击复制" placement="top">
                    <span class="originColor triangPopup" @click="doCopy('862458339')" >862458339 </span> 
                  </el-tooltip>；
                  微信：
                  <el-tooltip class="item" effect="dark" content="点击复制" placement="top">
                    <span class="originColor triangPopup" @click="doCopy('XIMITOOLBOX')">XIMITOOLBOX </span>
                  </el-tooltip> 。
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sogoDesignerLove flex-align-center flex-center">
      <div class="banXin">
        <div class="sogoFreeTitle">
          免费使用所有功能，直用到您觉得物有所值，再考虑是否购买成为西米工具箱会员，无需等待，直接起飞
        </div>
        <a class="sogoFreeBtn downloadA" target="_blank" href="https://s.rendercool.com/#/login">
          立即体验
        </a>
        <div class="sogoFreeWrap flex-align-center flex-center">
          <div class="sogoFreeItem flex-align-center flex-center">
            <img src="../assets/images/ximi/免费.png" alt="西米工具箱" class="sogoFreeImgT">
            <div class="sogoFreeTxt">
              永久免费版本更新
            </div>
          </div>
          <div class="sogoFreeItem flex-align-center flex-center">
            <img src="../assets/images/ximi/精品推荐.png" alt="西米工具箱" class="sogoFreeImgT">
            <div class="sogoFreeTxt">
              精品推荐优惠特价
            </div>
          </div>
          <div class="sogoFreeItem flex-align-center flex-center">
            <img src="../assets/images/ximi/专属客服.png" alt="西米工具箱" class="sogoFreeImgT">
            <div class="sogoFreeTxt">
              专属客服配套售后
            </div>
          </div>
          <div class="sogoFreeItem flex-align-center flex-center">
            <img src="../assets/images/ximi/官方教程.png" alt="西米工具箱" class="sogoFreeImgT">
            <div class="sogoFreeTxt">
              官方教程免费培训
            </div>
          </div>
          <div class="sogoFreeItem flex-align-center flex-center">
            <img src="../assets/images/ximi/账户登录.png" alt="西米工具箱" class="sogoFreeImgT">
            <div class="sogoFreeTxt">
              账户登录不限电脑
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="flex-center">
      <div class="footer">
        Copyright © {{ year }} rendercool.com 备案号：<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">宁ICP备2023000159号-1</a><a href="sitemap.htm">网站地图</a>
      </div>
    </footer>
  </div>
</template>

<script>
import Nav from '../components/Nav/index.vue'

export default {
  name: "Ximi",
  components: {
    Nav
  },
  data() {
    return {
      active: 0,
      year: new Date().getFullYear(),
      HPList: [
        {
          title: '单双面快速建模',
          desc: '极速单双面建模系统，节省大量的基础操作的时间，减少加班概率',
          img: require('../assets/images/ximi/单面建模.gif')

        },
        {
          title: '生长动画',
          desc: '一键生成随机生长动画',
          img: require('../assets/images/ximi/生长动画.gif')
        },
        {
          title: '一键模型转换CAD图形',
          desc: '选择所需的模型，一键转化生成CAD三视图图形，方便简单快捷',
          img: require('../assets/images/ximi/一键模型转换CAD.gif')
        },
        {
          title: 'ACEScg工作流（VR5+）',
          desc: '一键ACEScg工作流转换、渲染不曝光不灰',
          img: require('../assets/images/ximi/ACEScg工作流.gif')
        },
        {
          title: '智能素材管理',
          desc: '超强素材库，支持网上绝大多数素材直接导入，无需任何手动整理，直接拖拽入库；支持压缩包直接导入，无需解压，导入不丢贴图',
          img: require('../assets/images/ximi/智能素材管理.gif')
        },
      ]
    }
  },
  mounted() {
    // Any additional logic for when the component is mounted
  },
  methods: {
    payForX () {
      window.open('https://s.rendercool.com/#/register?flag=register&type=ximi', '_blank')
    },
    doCopy(txt) {
      this.$copyText(txt).then(() => {
        // success
        this.$message.success('复制成功')
      }, (e) => {
        // fail
        console.log(e);
        this.$message.error('复制失败')
      })
    }
  }
}

</script>

<style lang="scss" scoped>
@import url('../style/ximi.scss');
</style>
